$(function () {
    $('#filters-btn').click(function() {
        $('#filters-container').show();
        $('#filters-container').removeClass('d-none');
        $('header').addClass('fixed-head');
        $('body').addClass('fixed-page');
        $('#filters-btn').addClass('d-none');
        $('#filters-btn').removeClass('d-block');
    });

    $('#filters-btn-hidden').click(function() {
        $('#filters-container').hide();
        $('#filters-container').addClass('d-none');
        $('header').removeClass('fixed-head');
        $('body').removeClass('fixed-page');
        $('#filters-btn').removeClass('d-none');
        $('#filters-btn').addClass('d-block');
    });
});
